import type { ConstValues } from '@openx/types/helpers.ts';
import type { OptionsObject } from 'notistack';
import type { Action } from 'redux';

export interface Notification {
  id?: string;
  message: string;
  options: OptionsObject;
}

export const NotificationActionType = {
  ENQUEUE_NOTIFICATION: 'ENQUEUE_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
} as const;
export type NotificationActionType = ConstValues<typeof NotificationActionType>;

export interface NotificationAction extends Action<NotificationActionType> {
  notification: Notification;
  [key: string]: unknown;
}

export function enqueueNotification(notification): NotificationAction {
  return {
    notification,
    type: NotificationActionType.ENQUEUE_NOTIFICATION,
  };
}

export function removeNotification(notification): NotificationAction {
  return {
    notification,
    type: NotificationActionType.REMOVE_NOTIFICATION,
  };
}

/* Display error message and returns error ready for dispatch */
export const enqueueErrorNotification = (msg: string, err?: unknown) => {
  // biome-ignore lint/suspicious/noConsole: logging error in console
  err && console.error(msg, err);

  return enqueueNotification({
    message: msg,
    options: {
      variant: 'error',
    },
  });
};
